module.exports = __webpack_public_path__ + "img/girl.ab2b2550.png";